import { Helmet } from 'react-helmet'

function PiegadesNoteikumi() {
  // Check localStorage for the 'lang' key
  const lang = localStorage.getItem('lang');

  // --- English Version ---
  // If lang is 'en', display the English translation
  if (lang === 'en') {
    return (
      <div className="noteikumi piegade" style={{minHeight: "calc(-60px + 100vh - var(--header-height))"}}>
        <Helmet>
          <title>Nora Spora - Delivery Terms</title>
          <meta name="description" content="Explore our delivery terms to find out how we will deliver your order." />
          <meta name="keywords" content="privacy policy, data protection, personal data, NORA SPORA, delivery terms" />
          <meta name="robots" content="index, follow" />
        </Helmet>
          <h2 className="light">Delivery Terms</h2>
          <ul>
              <li>Orders are delivered within 2–5 business days (of course, we strive to deliver as quickly as possible).</li>
              <li>Delivery is available within the territory of the Republic of Latvia (to other territories by separate agreement).</li>
              <li>Standard delivery of ordered products is carried out via Omniva parcel lockers to the address you provide.</li>
              <li>Free delivery for orders over €40.</li>
              <li>€2.99 – standard delivery to Omniva parcel lockers for orders up to €40.</li>
              <li style={{fontWeight: "500"}}>Additional delivery information:
                  <ul style={{listStyle:"disc", paddingLeft:"20px", fontWeight:"400"}}>
                      <li>Attention: Upon receiving the shipment, please check the condition of the package. If there is any damage or suspicion of damage, send an email within 48 hours of receiving the product with your objection and a specification of the damage to info@noraspora.lv.</li>
                      <li>If any item is missing from the shipment or the package appears damaged, please inform us via email: info@noraspora.lv.</li>
                  </ul>
              </li>
          </ul>
      </div>
    )
  }

  // --- Default Latvian Version ---
  // If lang is not 'en' (or is null/undefined), display the original Latvian
  return (
    <div className="noteikumi piegade" style={{minHeight: "calc(-60px + 100vh - var(--header-height))"}}>
      <Helmet>
        <title>Nora Spora - Piegādes noteikumi</title>
        <meta name="description" content="Izpētiet mūsu piegādes noteikumus, lai uzzinātu kā mēs piegādāsim Jūsu pasūtījumu." />
        <meta name="keywords" content="privātuma politika, datu aizsardzība, personas dati, NORA SPORA" />
        <meta name="robots" content="index, follow" />
      </Helmet>
        <h2 className="light">Piegādes nosacījumi</h2>
        <ul>
            <li>Pasūtījumus piegādājam 2-5 darba dienu laikā (protams, cenšamies piegādāt pēc iespējas ātrāk).</li>
            <li>Piegāde notiek Latvijas Republikas teritorijas robežās (uz citām teritorijām pēc atsevišķa vienošanās).</li>
            <li>Standarta piegāde pasūtītajām precēm tiek veikta ar Omniva pakomātu pakalpojumiem uz Jūsu norādīto adresi</li>
            <li>Bezmaksas piegāde sūtījumiem virs 40 eiro</li>
            <li>2,99 €  – standarta piegāde uz Omniva pakomātiem sūtījumiem līdz 40 €.</li>
            <li style={{fontWeight: "500"}}>Papildu informācija par piegādi:
                <ul style={{listStyle:"disc", paddingLeft:"20px", fontWeight:"400"}}>
                    <li>Uzmanību: Saņemot sūtījumu, lūdzu, pārbaudiet sūtījuma iepakojuma stāvokli. Ja ir radušies bojājumi vai ir aizdomas par bojājumiem, 48h laikā kopš preces saņemšanas, raksties e-pastu ar šo iebildumu un bojājumu specifikāciju uz info@noraspora.lv.</li>
                    <li>Ja sūtījumā nav kādas preces vai šķiet, ka iepakojums ir bojāts, lūdzu, informējiet mūs pa e-pastu:s info@noraspora.lv.</li>
                </ul>
            </li>
        </ul>
    </div>
  )
}

export default PiegadesNoteikumi